import { Page, Text, View } from "@react-pdf/renderer";

import {
  getClinicAddress,
  getCrmParts,
  getMedFields,
  getPatientCpf,
  getPatientName,
  getPrescritorNome,
  NotificationDigitalFooter,
  NotificationStripe,
  notificationStyles as s,
  RECEITA_STRIPE,
  type NotificationPdfProps,
} from "./notificationShared";

export function NotificationReceitaRetinoides({
  filterSpecialMedication,
  dataPdf,
  linkDocument,
  qrCodeDataUrl,
  qrCodeSncrDataUrl,
  sncrConsultaUrl,
}: NotificationPdfProps) {
  const item = filterSpecialMedication?.[0];
  const med = getMedFields(item);
  const { crm, uf } = getCrmParts(dataPdf);
  const address = getClinicAddress(dataPdf);

  return (
    <Page size="A4" style={s.page}>
      <NotificationStripe color={RECEITA_STRIPE.NRR} />

      <View style={s.headerRow}>
        <View style={s.titleBlock}>
          <Text style={s.titleMain}>NOTIFICAÇÃO DE RECEITA ESPECIAL</Text>
          <Text style={[s.eletronica, { letterSpacing: 0.5, fontSize: 11 }]}>
            RETINÓIDES SISTÊMICOS
          </Text>
          <Text style={s.eletronica}>ELETRÔNICA</Text>
        </View>
        <View style={s.numeroWrap}>
          <Text style={s.numeroLabel}>N.º</Text>
          <Text style={s.numeroValue}>{med.sncrNumero || ""}</Text>
        </View>
      </View>

      <View style={s.twoCol}>
        <View style={s.col}>
          <View style={s.colHeader}>
            <Text style={s.colTitle}>Emitente</Text>
          </View>
          <View style={s.colBody}>
            <Text style={s.field}>
              Nome do médico:{" "}
              <Text style={s.value}>{getPrescritorNome(dataPdf)}</Text>
            </Text>
            <Text style={s.field}>
              Inscrição no CRM / UF:{" "}
              <Text style={s.value}>
                {crm && uf ? `${crm} / ${uf}` : ""}
              </Text>
            </Text>
            <Text style={s.field}>
              Endereço completo: <Text style={s.value}>{address}</Text>
            </Text>
            <Text style={s.field}>
              Telefone: <Text style={s.value}></Text>
            </Text>
          </View>
        </View>
        <View style={s.col}>
          <View style={s.colHeader}>
            <Text style={s.colTitle}>Paciente</Text>
          </View>
          <View style={s.colBody}>
            <Text style={s.field}>
              Nome: <Text style={s.value}>{getPatientName(dataPdf)}</Text>
            </Text>
            <Text style={s.field}>
              CPF ou, se estrangeiro, passaporte:{" "}
              <Text style={s.value}>{getPatientCpf(dataPdf)}</Text>
            </Text>
            <Text style={s.field}>
              Endereço completo: <Text style={s.value}></Text>
            </Text>
            <Text style={s.field}>
              Data de nascimento: <Text style={s.value}></Text>
            </Text>
            <Text style={s.field}>
              Sexo: <Text style={s.value}></Text>
            </Text>
          </View>
        </View>
      </View>

      <View style={{ flexDirection: "row", gap: 8, flexGrow: 1 }}>
        <View style={[s.prescriptionBox, { flex: 1, marginBottom: 12 }]}>
          <View style={s.prescriptionHeader}>
            <Text style={s.prescriptionTitle}>Prescrição</Text>
          </View>
          <View style={s.prescriptionBody}>
            <Text style={s.fieldSpaced}>
              Nome do medicamento ou substância:{" "}
              <Text style={s.value}>{med.nome}</Text>
            </Text>
            <Text style={s.fieldSpaced}>
              Concentração: <Text style={s.value}>{med.concentracao}</Text>
            </Text>
            <Text style={s.fieldSpaced}>
              Forma farmacêutica: <Text style={s.value}>{med.forma}</Text>
            </Text>
            <Text style={s.fieldSpaced}>
              Quantidade: <Text style={s.value}>{med.quantidade}</Text>
            </Text>
            <Text style={s.fieldSpaced}>
              Posologia: <Text style={s.value}>{med.posologia}</Text>
            </Text>
          </View>
        </View>
        <View
          style={[
            s.warningBox,
            { width: 130, justifyContent: "center", marginBottom: 12 },
          ]}
        >
          <Text style={s.warningText}>GRAVIDEZ PROIBIDA</Text>
          <Text style={{ fontSize: 7, textAlign: "center" }}>
            Risco de graves defeitos na face, nas orelhas, no coração e no
            sistema nervoso do feto.
          </Text>
        </View>
      </View>

      <NotificationDigitalFooter
        linkDocument={linkDocument}
        qrCodeDataUrl={qrCodeDataUrl}
        qrCodeSncrDataUrl={qrCodeSncrDataUrl}
        sncrConsultaUrl={sncrConsultaUrl}
      />
    </Page>
  );
}
